<template>
  <div class="nb-modal-scrollable">
    <div class="container nb-modal-scrollable-container">
      <div class="nb-modal-header">
        <h4 class="def-title">Item do Pedido de Compra</h4>
        <button type="button" class="close" @click="$emit('closeform')">&times;</button>
      </div>
      <div class="nb-modal-scrollable-body p-4">
        <div class="row">
          <div class="col-12">
            <v-label :metadata-field="metadata.comprait.coditem"></v-label>
            <div class="">
              <input-item ref="item" v-model="item.coditem" :add-button="true" @onselect="handleProductSelect"></input-item>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <form-field v-model="item.quantidade" type="value" col="3" :metadata="metadata.comprait.quantidade" @input="updateTotal" name="quantidade" :v-errors="errors" v-validate="metadata.comprait.quantidade.validator"></form-field>
          <form-field v-model="item.unidade" type="text" col="2" :metadata="metadata.comprait.unidade" name="unidade" :v-errors="errors" v-validate="metadata.comprait.unidade.validator"></form-field>
          <form-field v-model="item.preco" type="value" col="3" :metadata="metadata.comprait.preco" @input="updateTotal" name="preco" :v-errors="errors" v-validate="metadata.comprait.preco.validator"></form-field>
          <form-field v-model="item.total" type="value" col="4" :metadata="metadata.comprait.total" disabled name="total" :v-errors="errors" v-validate="metadata.comprait.total.validator"></form-field>
        </div>
        <div class="row mt-3">
          <form-field v-model="item.obsitem" type="memo" col="12"
              :metadata="metadata.comprait.obsitem"
              name="obsitem"
              :v-errors="errors"
              v-validate="metadata.comprait.obsitem.validator">
          </form-field>
        </div>
      </div>
      <div class="nb-modal-scrollable-footer p-3 text-right">
        <v-button label="Cancelar" @click="$emit('closeform')"></v-button>
        <v-button label="Salvar Item" :success="true" icon="fa-check" @click="handleSave"></v-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: ['value', 'metadata'],
  data() {
    return {
      item: { ...this.value }
    }
  },
  methods: {
    handleProductSelect(prod) {
      if (prod) {
        this.item.coditem = prod.coditem
        this.item.dscitem = prod.descricao
        this.item.unidade = prod.uni
        this.item.preco = prod.precocusto || prod.precovenda || prod.vlrtab
        this.updateTotal()
      }
    },
    updateTotal() {
      this.item.total = (this.item.quantidade || 0) * (this.item.preco || 0)
    },
    async handleSave() {
      this.$emit('save', this.item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/compra-item.vue